export default __webpack_public_path__ + "static/media/elevate-bpn-banner-1.b5e3071a.jpg";